export default __webpack_public_path__ + "static/media/tag-small.ac1a910c.svg";